import { generateNonce, verifySiwf } from "./actions/index.js";
import { createConfig } from "./config.js";
/**
 * For use on frontends where JWT verification is not necessary.
 *
 * This function is exported (as a named export) from the main `'quick-auth'` module
 * entry point as well as from its subpath export `'quick-auth/light'`.
 */
export function createLightClient(options = {}) {
    const config = createConfig(options);
    return {
        generateNonce: () => generateNonce(config),
        verifySiwf: (options) => verifySiwf(config, options),
    };
}
